import {FETCH_USER, FETCH_USER_ERROR} from "../actions/types";

const initialState = {user: null, error: null};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case (FETCH_USER):
            return {
                ...state,
                user: action.payload || false,
                error: null
            };
        case (FETCH_USER_ERROR): {
            return {
                ...state,
                user: null,
                error: action.error
            }
        }
        default:
            return state;
    }
};

export default authReducer;